import './index.less';

import SourceSettingsConfluence from './SourceSettingsConfluence';
import SourceSettingsFile from './SourceSettingsFile';
import SourceSettingsELMA365 from './SourceSettingsELMA365';
import SourceSettingsWebsite from './SourceSettingsWebsite';

type SourceSettingsSubComponents = {
  Website: typeof SourceSettingsWebsite;
  File: typeof SourceSettingsFile;
  Confluence: typeof SourceSettingsConfluence;
  ELMA365: typeof SourceSettingsELMA365;
};

const SourceSettings: SourceSettingsSubComponents = () => null;

SourceSettings.Website = SourceSettingsWebsite;
SourceSettings.File = SourceSettingsFile;
SourceSettings.Confluence = SourceSettingsConfluence;
SourceSettings.ELMA365 = SourceSettingsELMA365;

export default SourceSettings;
